export default "__VITE_ASSET__sTNkB4Ya__"